module.exports = __webpack_public_path__ + "static/img/home_yali_photo2@2x.ff6de2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_yali_photo2@2x.png
// module id = 9WOe
// module chunks = 0